import { Injectable } from '@angular/core';

@Injectable({ providedIn:'root' })
export class UserCenterService {
    userCenterComponent: any
    loadUserCenterComponent() {
        return this.userCenterComponent;
    }
}